{
  "enums": {
    "claimStatus": {
      "draft": "초안",
      "submitted": "제출됨",
      "accepted": "승인됨",
      "denied": "거부됨",
      "paid": "지급됨"
    },
    "chargeStatus": {
      "pending": "대기 중",
      "unbilled": "미청구",
      "posted": "기표됨",
      "billed": "청구됨",
      "adjusted": "조정됨",
      "voided": "무효 처리됨"
    },
    "statementDelivery": {
      "print": "인쇄",
      "email": "이메일",
      "both": "인쇄 및 이메일",
      "mail": "우편"
    },
    "statementStatus": {
      "generated": "생성됨",
      "sent": "전송됨",
      "viewed": "조회됨"
    },
    "denialStatus": {
      "new": "신규",
      "inReview": "검토 중",
      "appealing": "이의 제기 중",
      "resolved": "해결됨",
      "writtenOff": "대손 처리됨"
    },
    "denialPriority": {
      "low": "낮음",
      "medium": "보통",
      "high": "높음"
    },
    "claimType": {
      "professional": "전문의",
      "institutional": "기관",
      "dental": "치과",
      "pharmacy": "약국"
    },
    "paymentMethod": {
      "cash": "현금",
      "check": "수표",
      "creditCard": "신용카드",
      "debitCard": "직불카드",
      "bankTransfer": "계좌 이체",
      "digitalWallet": "전자지갑",
      "insurance": "보험"
    },
    "paymentSource": {
      "patient": "환자",
      "insurance": "보험",
      "thirdParty": "제3자"
    }
  },
  "form": {
    "validation": {
      "patientIdRequired": "환자 ID는 필수입니다",
      "encounterIdRequired": "진료 ID는 필수입니다",
      "payerIdRequired": "지급자 ID는 필수입니다",
      "chargeCodeRequired": "청구 코드는 필수입니다",
      "unitPriceRequired": "단가는 필수입니다",
      "amountRequired": "금액은 필수입니다",
      "amountPositive": "금액은 0보다 커야 합니다",
      "chargeSelectionRequired": "청구 항목을 하나 이상 선택하세요"
    }
  },
  "pages": {
    "statements": {
      "title": "청구 명세서",
      "labels": {
        "dashboard": "대시보드",
        "patient": "환자",
        "from": "시작",
        "to": "종료",
        "batchGenerate": "일괄 생성",
        "previewStatement": "명세서 미리보기",
        "generatePrint": "생성 및 인쇄",
        "generateEmail": "생성 및 이메일 발송",
        "printEmail": "인쇄 및 이메일",
        "print": "인쇄",
        "email": "이메일"
      },
      "placeholders": {
        "searchPatient": "이름 또는 MRN으로 검색..."
      },
      "aria": {
        "periodFrom": "명세서 기간 시작",
        "periodTo": "명세서 기간 종료"
      },
      "table": {
        "header": {
          "statementHistory": "명세서 이력",
          "patient": "환자",
          "mrn": "MRN",
          "date": "날짜",
          "amount": "금액",
          "delivery": "발송 방법",
          "status": "상태"
        },
        "preview": {
          "modal": "명세서 미리보기",
          "patientStatement": "환자 명세서",
          "patient": "환자:",
          "mrn": "MRN:",
          "statementDate": "명세서 날짜:",
          "period": "기간:",
          "lineItemHeader": {
            "date": "날짜",
            "description": "설명",
            "charges": "청구",
            "payments": "결제",
            "balance": "잔액"
          },
          "openingBalance": "기초 잔액",
          "totals": "합계",
          "amountDue": "청구 금액"
        }
      },
      "states": {
        "generating": "생성 중...",
        "loading": "미리보기 생성 중...",
        "noPatients": "환자를 찾을 수 없습니다",
        "noStatementData": "사용 가능한 명세서 데이터가 없습니다",
        "loadingHistory": "이력 로드 중...",
        "noStatementsGenerated": "아직 생성된 명세서가 없습니다",
        "selectedPatientId": "선택된 환자 ID: {{id}}"
      },
      "toast": {
        "generated": "명세서가 생성되었습니다",
        "generatedError": "명세서 생성에 실패했습니다",
        "batchStarted": "일괄 생성을 시작했습니다: 명세서 {{count}}건이 대기열에 추가되었습니다",
        "batchError": "일괄 생성 시작에 실패했습니다"
      }
    },
    "claims": {
      "title": "청구 관리",
      "labels": {
        "dashboard": "대시보드",
        "createClaim": "청구 생성",
        "filters": "필터",
        "submit": "제출",
        "appeal": "이의 제기",
        "denialReason": "거부 사유",
        "expandHint": "전용 청구 페이지에서 항목을 보려면 청구를 펼치세요.",
        "cancel": "취소"
      },
      "filter": {
        "allStatuses": "모든 상태"
      },
      "placeholders": {
        "filterPayer": "지급자로 필터링..."
      },
      "aria": {
        "claimDateFrom": "청구 시작일",
        "claimDateTo": "청구 종료일"
      },
      "table": {
        "header": {
          "claimNumber": "청구 #",
          "patient": "환자",
          "payer": "지급자",
          "total": "합계",
          "status": "상태",
          "submitted": "제출됨",
          "actions": "작업"
        }
      },
      "modal": {
        "createClaim": "청구 항목으로 청구 생성",
        "patientId": "환자 ID *",
        "payerId": "지급자 ID *",
        "selectCharges": "청구 항목 선택 ({{selected}}개 선택됨)",
        "noBilledCharges": "이 환자에 대한 미청구 항목이 없습니다"
      },
      "states": {
        "loading": "청구를 불러오는 중...",
        "noClaims": "청구를 찾을 수 없습니다",
        "creating": "생성 중..."
      },
      "toast": {
        "created": "청구가 생성되었습니다",
        "createdError": "청구 생성에 실패했습니다",
        "submitted": "청구가 제출되었습니다",
        "submittedError": "청구 제출에 실패했습니다",
        "resubmitted": "이의 제기를 위해 청구가 재제출되었습니다",
        "resubmittedError": "청구 재제출에 실패했습니다",
        "patientPayerRequired": "환자와 지급자가 필요합니다",
        "chargeRequired": "최소 하나의 청구 항목을 선택하세요"
      }
    },
    "charges": {
      "title": "청구 항목 관리",
      "labels": {
        "dashboard": "대시보드",
        "newCharge": "새 청구 항목",
        "totalChargesPeriod": "총 청구 항목 (기간)",
        "filters": "필터",
        "cancel": "취소"
      },
      "filter": {
        "allStatuses": "모든 상태"
      },
      "placeholders": {
        "filterPatient": "환자로 필터링..."
      },
      "aria": {
        "serviceDateFrom": "진료일 시작",
        "serviceDateTo": "진료일 종료"
      },
      "table": {
        "header": {
          "date": "날짜",
          "patient": "환자",
          "encounter": "진료",
          "code": "코드",
          "description": "내용",
          "qty": "수량",
          "unitPrice": "단가",
          "total": "합계",
          "status": "상태",
          "actions": "작업"
        }
      },
      "actions": {
        "void": "취소"
      },
      "modal": {
        "voidCharge": "청구 항목 취소",
        "voidChargeConfirm": "청구 항목 {{code}} - {{description}} ({{amount}})을(를) 취소하시겠습니까?",
        "reason": "사유 *",
        "reasonPlaceholder": "취소 사유를 입력하세요..."
      },
      "states": {
        "loading": "청구 항목을 불러오는 중...",
        "noCharges": "이 기간에 청구 항목이 없습니다",
        "voiding": "취소 중..."
      },
      "toast": {
        "voided": "청구 항목이 취소되었습니다",
        "voidedError": "청구 항목 취소에 실패했습니다",
        "reasonRequired": "사유는 필수입니다"
      }
    },
    "payments": {
      "title": "결제 등록",
      "labels": {
        "dashboard": "대시보드",
        "uploadEraEob": "ERA/EOB 업로드",
        "postPayment": "결제 등록",
        "totalPaymentsPeriod": "총 결제 (기간)",
        "filters": "필터",
        "cancel": "취소"
      },
      "placeholders": {
        "filterPatient": "환자로 필터링..."
      },
      "aria": {
        "paymentDateFrom": "결제일(시작)",
        "paymentDateTo": "결제일(종료)"
      },
      "table": {
        "header": {
          "date": "날짜",
          "patient": "환자",
          "claimNumber": "청구 #",
          "amount": "금액",
          "method": "방법",
          "reference": "참조",
          "postedBy": "등록자"
        }
      },
      "modal": {
        "postPayment": "결제 등록",
        "patientId": "환자 ID *",
        "claimId": "청구 ID (선택 사항)",
        "claimIdHint": "미적용 결제는 비워 두세요",
        "amount": "금액 *",
        "method": "방법 *",
        "referenceNumber": "참조 번호",
        "referenceHint": "수표 번호, 거래 ID 등",
        "notes": "메모"
      },
      "states": {
        "loading": "결제를 불러오는 중...",
        "noPayments": "이 기간에 결제가 없습니다",
        "posting": "등록 중..."
      },
      "toast": {
        "posted": "결제가 성공적으로 등록되었습니다",
        "postedError": "결제 등록에 실패했습니다",
        "patientAmountRequired": "환자와 금액은 필수입니다",
        "validAmount": "유효한 금액을 입력하세요",
        "eraEobSoon": "ERA/EOB 업로드 기능이 곧 제공됩니다"
      }
    },
    "chargeForm": {
      "title": "청구 항목 생성",
      "labels": {
        "patientId": "환자 ID *",
        "encounterId": "진료 ID *",
        "chargeCode": "청구 코드 *",
        "description": "설명",
        "cptCode": "CPT 코드",
        "quantity": "수량 *",
        "unitPrice": "단가 *"
      },
      "placeholders": {
        "chargeCode": "청구 마스터 검색...",
        "cptCode": "CPT 시술 코드 검색..."
      },
      "buttons": {
        "cancel": "취소",
        "create": "청구 항목 생성"
      },
      "toast": {
        "created": "청구 항목이 생성되었습니다",
        "createdError": "청구 항목 생성에 실패했습니다"
      }
    },
    "claimForm": {
      "title": "청구 생성",
      "labels": {
        "patientId": "환자 ID *",
        "encounterId": "진료 ID *",
        "payerId": "지급자 ID *",
        "claimType": "청구 유형 *",
        "diagnosisCodes": "진단 코드",
        "selectCharges": "청구 항목 선택 ({{selected}}개 선택됨)",
        "notes": "메모"
      },
      "placeholders": {
        "diagnosisCodes": "쉼표로 구분된 ICD-10 코드 (예: J06.9, R05)"
      },
      "buttons": {
        "cancel": "취소",
        "create": "청구 생성"
      },
      "toast": {
        "created": "청구가 생성되었습니다",
        "createdError": "청구 생성에 실패했습니다"
      }
    },
    "paymentForm": {
      "title": "결제 등록",
      "labels": {
        "patientId": "환자 ID *",
        "claimId": "청구 ID",
        "amount": "금액 *",
        "method": "결제 방법 *",
        "source": "출처",
        "referenceNumber": "참조 번호",
        "notes": "메모"
      },
      "placeholders": {
        "claimId": "선택 사항 — 청구에 연결",
        "reference": "거래 또는 수표 참조"
      },
      "buttons": {
        "cancel": "취소",
        "post": "결제 등록"
      },
      "toast": {
        "recorded": "결제가 기록되었습니다",
        "recordedError": "결제 기록에 실패했습니다"
      }
    },
    "denials": {
      "title": "거부 관리",
      "subtitle": "청구 거부를 추적하고 관리합니다",
      "placeholders": {
        "search": "청구 검색..."
      },
      "filter": {
        "all": "전체"
      },
      "checkbox": {
        "assignedToMe": "내 담당"
      },
      "table": {
        "header": {
          "claimNumber": "청구 번호",
          "patient": "환자",
          "denialCode": "거부 코드",
          "denialReason": "거부 사유",
          "amount": "금액",
          "daysRemaining": "남은 일수",
          "status": "상태",
          "assignedTo": "담당자",
          "actions": "작업"
        }
      },
      "actions": {
        "review": "검토",
        "appeal": "이의 제기",
        "writeOff": "상각",
        "cancel": "취소"
      },
      "modal": {
        "appealReason": "이의 제기 사유",
        "appealPlaceholder": "이의 제기 사유를 입력하세요...",
        "submitAppeal": "이의 제기 제출",
        "writeOffTitle": "거부 상각",
        "writeOffConfirm": "청구 {{claimNumber}}을(를) {{amount}}로 상각하시겠습니까? 이 작업은 취소할 수 없습니다.",
        "writeOffButton": "상각"
      },
      "states": {
        "loading": "거부 불러오는 중...",
        "noDenials": "거부를 찾을 수 없습니다",
        "submitting": "제출 중..."
      },
      "toast": {
        "updateError": "거부 상태 업데이트에 실패했습니다",
        "movedToReview": "청구 {{claimNumber}}을(를) 검토로 이동했습니다",
        "appealSubmitted": "이의 제기를 제출했습니다",
        "writtenOff": "청구 {{claimNumber}}을(를) 상각했습니다"
      }
    }
  },
  "__review_denialReason": "Backend payer-authored — Phase 9, do not translate",
  "__review_denialCode": "Backend payer-authored — Phase 9, do not translate",
  "__review_chargeDescription": "Backend payer-authored — Phase 9, do not translate",
  "__review_chargeCode": "Backend payer-authored — Phase 9, do not translate"
}
